require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// ./node_modules/.2.5.3@core-js/library/modules/es7.symbol.observable.js
// module id = 265
// module chunks = 0